/**
 * SeasonalController — /api/v1/seasonal
 * Mirrors: src/Aidepo.Api/Controllers/SeasonalController.cs
 *
 * Phase 3.12 — seasonal checklists. GET builds (and persists) a checklist for
 * the given season against the user's real equipment; POST .../done marks an
 * item complete via MutationService (reversible).
 */
import { apiGet, apiPost } from '../client.js';
import type { Uuid } from '../types.js';

/** Supported seasons (must match SeasonalAdvisor.Seasons on the backend). */
export type Season = 'summer' | 'winter' | 'spring' | 'autumn';

export const SEASONS: readonly Season[] = ['summer', 'winter', 'spring', 'autumn'] as const;

/** One checklist row. */
export interface SeasonalItem {
  readonly id: Uuid;
  readonly title: string;
  readonly equipmentId: Uuid | null;
  readonly isSafety: boolean;
  readonly isDone: boolean;
}

export interface SeasonalChecklistResponse {
  readonly season: Season;
  readonly items: readonly SeasonalItem[];
}

/** GET /api/v1/seasonal/{season} — seasonal checklist for the user's equipment. */
export function getSeasonalChecklist(season: Season): Promise<SeasonalChecklistResponse> {
  return apiGet<SeasonalChecklistResponse>(`/api/v1/seasonal/${season}`);
}

/** POST /api/v1/seasonal/{id}/done — mark (or unmark) a checklist item. */
export function setSeasonalItemDone(id: Uuid, isDone = true): Promise<unknown> {
  return apiPost<unknown, { isDone: boolean }>(`/api/v1/seasonal/${id}/done`, { isDone });
}
